function Other(props) {
    return (<li>
        <p className="title-overline">{props.title}</p>
        <p>{props.subTitle}</p>
    </li>)
}

export default Other;